<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
      default: ''
    },
    link: {
      type: String,
      required: true,
      default: ''
    },
    text: {
      type: String,
      required: false,
      default: ''
    }
  },
  name: 'TheBanner'
}
</script>

<template>
  <div class="banner">
    <div class="banner__wrapper">
      <div class="banner__column">
        <router-link v-if="link" :to="link" class="banner__link">
          <h4 class="banner__title" v-html="title"></h4>
          <p v-if="text">
            {{ text }}
          </p>
        </router-link>
      </div>
      <div class="banner__picture">
        <slot name="img"></slot>
      </div>
      <a
        @click.prevent="$emit('closeBanner')"
        class="banner__close btn-close"
      ></a>
    </div>
  </div>
</template>

<style scoped lang="scss">
.banner {
  margin-bottom: 24px;

  p {
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
    color: #002856;
  }
}

.banner__wrapper {
  position: relative;
  display: flex;
  gap: 30px;
  justify-content: space-between;
  border-radius: 6px;
  background: $blue-light;
  padding: 20px 40px 25px 16px;
  min-height: 108px;
}

.banner__close {
  cursor: pointer;
  position: absolute;
  right: 9px;
  top: 9px;
}

.banner__column {
  position: relative;
  z-index: 3;
  max-width: 65%;
}

.banner__title {
  margin-bottom: 14px;
  color: $blue;
  font-size: 16px;
  font-weight: 700;
  line-height: 18px;
}

.banner__link {
  cursor: pointer;
  border-radius: 12px;
  color: #fff;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;

  &:hover {
    background: $blue-6;
  }
}

.banner__picture {
  z-index: 2;
  position: absolute;
  bottom: 0;
  right: 40px;

  & img {
    //width: 100px;
  }
}
</style>
